import React, { memo } from 'react'

import { useEventCapture } from '@surglogs-app/analytics'
import { getUserIdKey } from '@surglogs-app/auth'
import {
  getAuthLogoutRoute,
  redirectToExternalUrl,
} from '@surglogs-app/routing'
import { DefaultDialog } from '@surglogs-app/ui.dialog'

interface LogoutConfirmationDialogProps {
  hideModal: () => void
  title: string
  text: string
  confirmButtonLabel: string
}

export const LogoutConfirmationDialog = memo(
  ({
    hideModal,
    text,
    title,
    confirmButtonLabel,
  }: LogoutConfirmationDialogProps) => {
    const { captureEvent } = useEventCapture()

    return (
      <DefaultDialog
        {...{
          'aria-label': 'logout-confirmation',
          title,
          text,
          onConfirm: () => {
            hideModal()

            window.requestAnimationFrame(() => {
              captureEvent('user_signed_out')
              // We need to remove user id from storage before logout redirect otherwise token info is loaded for logout redirect
              window.sessionStorage.removeItem(getUserIdKey())
              window.localStorage.removeItem(getUserIdKey())
              // wait for tracking event to be triggered
              redirectToExternalUrl(getAuthLogoutRoute(), {
                replace: true,
              })
            })
          },
          confirmButtonLabel,
          onCancel: () => hideModal(),
        }}
      />
    )
  },
)
